import { CSSProperties } from 'react'
import { LandingButton } from '../primitives'

const enterDelay = (ms: number) => ({ '--l-enter-delay': `${ms}ms` }) as CSSProperties

export function LandingHero() {
  return (
    <section className="l-hero">
      <div className="l-hero__picture">
        <img
          src="/landing/rigs-1920.jpg"
          srcSet="/landing/rigs-1080.jpg 1080w, /landing/rigs-1920.jpg 1920w"
          sizes="max(100vw, 133svh)"
          width={1920}
          height={1439}
          alt="Eight overland rigs parked in a line on a cracked dry lakebed, with pale mesas behind them"
          // @ts-expect-error fetchpriority is valid HTML but missing from React 18's img typings
          fetchpriority="high"
        />
      </div>

      <div className="l-frame l-hero__rail">
        <h1 className="l-hero-title l-enter lg:col-span-5" style={enterDelay(100)}>
          Bring the crew.
          <br />
          Keep your spots.
        </h1>
        <p className="l-enter max-w-[38ch] lg:col-span-4 lg:col-start-7" style={enterDelay(170)}>
          The trip planner for overlanding crews. Routes, meals, gear and weather in one plan, shared on your terms.
        </p>
        <div className="l-enter mt-1 lg:col-span-2 lg:col-start-11 lg:mt-0 lg:justify-self-end" style={enterDelay(240)}>
          <LandingButton to="/signup" tone="ink">
            Start planning free
          </LandingButton>
        </div>
      </div>
    </section>
  )
}
